module.exports = __webpack_public_path__ + "static/img/6.38d0edc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/sp/6.png
// module id = 0WeH
// module chunks = 0